{
  "title": "Kommunikation",
  "subtitle": "Messenger und Kanäle die deinen Master-Agent erreichen",
  "whatsapp": {
    "label": "WhatsApp",
    "description": "Eingehende Nachrichten gehen direkt an deinen Master-Agent. Nur 1:1-Chats, kein Medien-Empfang.",
    "connect": "Verbinden",
    "disconnect": "Trennen",
    "qr_hint": "WhatsApp öffnen → Geräte verknüpfen → diesen Code scannen",
    "bridge_unavailable": "Bridge nicht verfügbar — Node.js installieren und im Bridge-Verzeichnis 'npm install' ausführen.",
    "bridge_error": "Bridge-Fehler: {{detail}}",
    "states": {
      "disconnected": "Nicht verbunden",
      "connecting": "Verbindet …",
      "waiting_qr": "Warte auf QR-Scan",
      "connected": "Verbunden",
      "error": "Fehler"
    },
    "filter": {
      "title": "Filter & Berechtigungen",
      "intro": "Diese Einstellungen gelten für deine WhatsApp-Verbindung. Owner umgehen alle Filter.",
      "loading": "Filter wird geladen …",
      "private_chats": "Private Nachrichten",
      "group_chats": "Gruppen-Nachrichten",
      "keyword_label": "Aktivierungs-Keyword (leer = immer antworten)",
      "keyword_placeholder": "z.B. !bot",
      "owner": "Eigene Nummern (Owner-Bypass)",
      "owner_hint": "Owner sehen alles, auch ohne Keyword/Whitelist.",
      "allowed": "Whitelist (leer = alle erlauben)",
      "allowed_hint": "Wenn gesetzt: nur diese Nummern dürfen.",
      "blocked": "Blacklist",
      "blocked_hint": "Diese Nummern werden immer ignoriert.",
      "save": "Speichern",
      "saved": "Gespeichert",
      "no_voices": "Keine Voices vom mmx-CLI geladen"
    }
  },
  "discord": {
    "label": "Discord",
    "description": "DMs und @Mentions gehen direkt an deinen Master-Agent.",
    "unavailable": "Discord nicht verfügbar.",
    "connect": "Verbinden",
    "disconnect": "Trennen",
    "states": {
      "disconnected": "Nicht verbunden",
      "connecting": "Verbindet …",
      "waiting_qr": "Verbindet …",
      "connected": "Verbunden",
      "error": "Fehler"
    },
    "filter": {
      "title": "Filter & Einstellungen",
      "intro": "Token, Filter und Verhalten für deinen Discord-Bot.",
      "loading": "Einstellungen werden geladen …",
      "token_label": "Bot-Token",
      "token_placeholder": "Discord Bot Token einfügen …",
      "token_hint": "Im Discord Developer Portal unter Bot → Token. 'Message Content Intent' muss aktiviert sein.",
      "setup_toggle": "So richtest du den Bot ein",
      "setup_step1_title": "1. Bot erstellen & Token holen",
      "setup_step1_body": "Discord Developer Portal öffnen → «New Application» → links «Bot» → «Reset Token» → Token kopieren und oben einfügen.",
      "setup_step2_title": "2. Message Content Intent aktivieren (wichtig!)",
      "setup_step2_body": "Im Bot-Tab unter «Privileged Gateway Intents» den Schalter «Message Content Intent» aktivieren und speichern. Ohne diesen Schalter verbindet sich der Bot nicht.",
      "setup_step3_title": "3. Bot auf deinen Server einladen",
      "setup_step3_body": "OAuth2 → URL Generator → Scope «bot» wählen → Permissions «View Channels», «Send Messages», «Read Message History» → generierte URL öffnen → Server auswählen → autorisieren.",
      "setup_step4_title": "4. Verbinden & testen",
      "setup_step4_body": "Oben auf «Verbinden» klicken. Danach dem Bot eine DM schicken oder ihn in einem Channel mit @Name erwähnen — er antwortet nur auf DMs und @Mentions.",
      "setup_portal_link": "Discord Developer Portal öffnen",
      "dm_enabled": "DMs empfangen",
      "mention_enabled": "@Mentions empfangen",
      "keyword_label": "Aktivierungs-Keyword (leer = immer antworten)",
      "keyword_placeholder": "z.B. !bot",
      "owner_users": "Besitzer (deine Discord-User-IDs)",
      "owner_users_hint": "Nachrichten dieser IDs gelten als vertrauenswürdig (wie du selbst) und umgehen die Whitelist. Ohne Eintrag behandelt der Bot auch dich als unbekannten Kontakt. In Server-Kanälen hat jeder Nutzer ein eigenes Gespräch mit dem Bot.",
      "allowed_users": "Whitelist User-IDs (leer = alle erlauben)",
      "allowed_users_hint": "Wenn gesetzt: nur diese Discord-User-IDs dürfen.",
      "blocked_users": "Blacklist User-IDs",
      "blocked_users_hint": "Diese User-IDs werden immer ignoriert.",
      "allowed_channels": "Whitelist Channel-IDs (leer = alle)",
      "allowed_channels_hint": "Wenn gesetzt: nur in diesen Channels auf @Mentions antworten. Gilt nicht für die Agenten-Werkzeuge (siehe unten).",
      "voice_label": "Als Sprachnachricht antworten",
      "save": "Speichern",
      "saved": "Gespeichert"
    },
    "tools": {
      "label": "Kanäle für Agenten-Werkzeuge",
      "hint": "Nur hier dürfen Agenten mit den Discord-Tools lesen und schreiben (Beiträge in einem Forum sind mit freigegeben). Nichts ausgewählt = kein Zugriff. Die Tools schaltest du pro Agent unter «Tools» frei.",
      "reload": "Neu laden",
      "not_connected": "Bot nicht verbunden — zuerst oben verbinden, dann erscheinen hier die Kanäle.",
      "no_channels": "Der Bot sieht keine Text- oder Forum-Kanäle. Ist er auf dem Server eingeladen?",
      "forum": "Forum",
      "read_only": "nur lesen",
      "unreachable": "nicht erreichbar",
      "none_selected": "Kein Kanal freigegeben — Agenten haben keinen Discord-Zugriff.",
      "count_one": "{{count}} Kanal freigegeben — speichern nicht vergessen.",
      "count_other": "{{count}} Kanäle freigegeben — speichern nicht vergessen.",
      "moderate": "Moderieren",
      "moderate_hint": "Moderations-Tools erlauben: Tags setzen, Beiträge schließen/sperren/anheften, Nachrichten anpinnen/löschen, Forum-Tags pflegen. Löschen muss immer bestätigt werden.",
      "moderated_count_one": "Davon {{count}} mit Moderation.",
      "moderated_count_other": "Davon {{count}} mit Moderation."
    },
    "admin": {
      "label": "Server verwalten",
      "hint": "Verwaltungswerkzeuge für diesen Server: Kategorien, Kanäle, Foren, Kanalrechte, Einladungen, Rollen, Nicknames, Timeout, Kick, Bann. Administrator und «Server verwalten» werden nie vergeben; Serverbesitzer, Bot und Besitzer-IDs sind geschützt. Löschen, Kick, Bann und Rechte fragen dich vorher.",
      "no_rights": "Der Bot hat auf diesem Server keine Verwaltungsrechte (Administrator oder Kanäle + Rollen verwalten).",
      "count_one": "{{count}} Server mit Verwaltung.",
      "count_other": "{{count}} Server mit Verwaltung."
    }
  }
}
